<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="position-relative cr_content h-auto table-container">
  <div class="detail-menu-container">
    <div id="{{ listOfChartCountsDetails.id }}" class="mini-chart-container" *ngFor="
          let listOfChartCountsDetails of UiMatrixList;
          let ix = index
        " (click)="onClickOnChart($event, listOfChartCountsDetails)"
      (keydown.enter)="onClickOnChart($event, listOfChartCountsDetails)">
      <div class="d-flex gap-2">
        <div>
          <div class="d-flex justify-content-center align-items-center requests_menu"
            *ngIf="listOfChartCountsDetails.status == 'Total'">
            <img src="../../../assets/img/cr_module/total_requests.svg" width="16px" height="16px"
              alt="total requests" />
          </div>
          <div class="d-flex justify-content-center align-items-center requests_menu closed_request"
            *ngIf="listOfChartCountsDetails.status == 'Completed'">
            <img src="../../../assets/img/cr_module/closed_requests.svg" width="16px" height="16px"
              alt="closed requests" />
          </div>
          <div class="d-flex justify-content-center align-items-center requests_menu active_request"
            *ngIf="listOfChartCountsDetails.status == 'Active'">
            <img src="../../../assets/img/cr_module/active_requests.svg" width="16px" height="16px"
              alt="active requests" />
          </div>

          <div class="d-flex justify-content-center align-items-center requests_menu overdue_request"
            *ngIf="listOfChartCountsDetails.status == 'Obsoleted'">
            <img src="../../../assets/img/cr_module/overdue_request.svg" width="16px" height="16px"
              alt="overdue requests" />
          </div>
          <div class="d-flex justify-content-center align-items-center requests_menu my_total_request"
            *ngIf="listOfChartCountsDetails.status == 'My Total'">
            <img src="../../../assets/img/cr_module/my_total.svg" width="16px" height="16px" alt="my total requests" />
          </div>
        </div>
        <div class="d-flex flex-column">
          <span class="chart-count">
            {{ listOfChartCountsDetails.count }}
          </span>
          <span class="d-flex px-1">
            <span class="chart-text me-2">
              {{ listOfChartCountsDetails.status }}
            </span>
            <span class="percentage-count">{{
              listOfChartCountsDetails.status == "Total"
              ? 100
              : listOfChartCountsDetails.percentage
              }}%</span>
          </span>
          <span class="progress-bar-container"
            [ngStyle]="{'background': listOfChartCountsDetails.colorCode, 'width': listOfChartCountsDetails.percentage + '%'}">
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex float-right" style="width:30%">
      <div><label for="email" style="margin-top: 12px;">Template&nbsp;&nbsp;</label></div>
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedTemplateMasterSearch"
        (closed)="templateSearchText1=''" (click)="focusSearch('focus-template-search')"
        (keydown.enter)="focusSearch('focus-template-search')">
        <input type="search" id="focus-template-search" class="dropdownsearchstyle" [(ngModel)]="templateSearchText1"
          matInput placeholder="search">
        <mat-option class="unselectStyle" [value]="null"
          (onSelectionChange)="getCallByTemplateId($event,null)">Un-select</mat-option>
        <mat-option *ngFor="let item of this.formsListTemplate | assessmentSearch : templateSearchText1"
          [value]="item.templateId" (onSelectionChange)="getCallByTemplateId($event,item)">
          {{ item.templateName }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="d-flex justify-content-end mb-3">
    <div class="d-flex gap-3">
      <div id="header-container">
        <div class="">
          <div class="search-container">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
              [(ngModel)]="searchValue" (input)="applyFilter2($event)" />
          </div>
        </div>
      </div>
      <div *ngIf="templateToAddFormDropdown.length != 0"
        class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openAddPopup()"
        (keydown.enter)="openAddPopup()">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
        (keydown.enter)="openAuditTrail('overAll',0)">

        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>

        <span class="reload_text text-white">Audit Trail</span>

      </div>
      <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="rerefreshGrid()"
        (keydown.enter)="rerefreshGrid()">
        <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
        <span class="reload_text">Reload</span>
      </div>
    </div>
  </div>
  <table class="dynamic-table-container">
    <tr>
      <th class="py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span></span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>Title</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>
      <th class="py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>Status</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>

      <th class="py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>Activity</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>

      <th class="py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>Header</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>

      <th class="py-2">
        <div class="d-flex justify-content-between align-items-center">
          <span>Footer</span>
          <img src="../../assets/img/DMS/sort.svg" width="7px" height="14px" alt="sort" />
        </div>
      </th>

    </tr>
    <tr *ngFor="
        let object of pagedItems | searchFilter : searchValue;let i = index">
      <td style="min-width: 50px;max-width: 50px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 25" fill="none"
          style="margin-left: 20%;">
          <path
            d="M7.20002 12.1471L10.2 15.1471L7.20002 18.1471M3.00002 8.54709H21M4.80002 22.3471C3.47454 22.3471 2.40002 21.2726 2.40002 19.9471V5.54709C2.40002 4.22161 3.47454 3.14709 4.80002 3.14709H19.2C20.5255 3.14709 21.6 4.22161 21.6 5.54709V19.9471C21.6 21.2726 20.5255 22.3471 19.2 22.3471H4.80002Z"
            stroke="#005C8A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </td>
      <td id="grid-row-container" style="max-width: 500px;min-width:500px;">
        <div>
          <div>
            <a href="#" class="file_name" (click)="goToDetail(object,$event)">{{ object.formName }}</a>

          </div>
          <div>
            <span *ngIf="object.formDescription != null">Description :{{ object.formDescription }}</span>
          </div>
          <div>
            <span>Template :
              {{ object.templateName }}</span>
          </div>
        </div>
      </td>

      <td style="min-width: 250px;max-width:250px;">
        <span [ngClass]="object.status == 'Inactive' ||
        object.status == 'Locked' ||
        object.status == 'Expired' ||
        object.status == 'Approval Rejected' ||
        object.status == 'Review Rejected' ||
        object.status.includes('Requested More Info.') ||
        object.status.includes('Expired') ||
        object.status.includes('Inactive') ||
        object.status == 'Obsoleted' ||
        object.status == 'Deleted' ? 'delete' : object.status == 'Open' ||
        object.status == 'Active' ? 'approve' : object.status == 'Draft' ||
        object.status == 'Pending Review' ||
        object.status == 'Pending Approval' ||
        object.status.includes('Inprogress') ||
        object.status == 'Pending Publish'  ? 'draft' :  object.status == 'Published' ||
        object.status.includes('Completed') ? 'closed' :''">{{ object.status }}</span>
      </td>

      <td class="grid-row-container" style="max-width: 500px;min-width:500px;">
        <div *ngIf="object.lockedBy != null">
          <span>Locked By :
            {{ object.lockedByUser }}</span>
        </div>
        <div *ngIf="object.createdByUser == object.updatedByUser">
          <span>Created On / By :
            {{ object.createdOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.createdByUser }}</span>
        </div>
        <div *ngIf="object.createdByUser != object.updatedByUser">
          <span>Created On / By :
            {{ object.createdOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.createdByUser }}</span>
        </div>
        <div *ngIf="object.createdByUser != object.updatedByUser">
          <span>Updated On / By :
            {{ object.updatedOn | date : uiDateTimeFormat | uppercase }} /
            {{ object.updatedByUser }}</span>
        </div>
        <div *ngIf="object.completedOn != null">
          <span>Completed On :
            {{ object.completedOn | date : uiDateTimeFormat | uppercase }} </span>
        </div>
      </td>

      <td style="min-width: 250px;max-width:250px;">
        <!-- {{ object.header }} -->
        <div class="download-button-continer btn-align" mat-dialog-actions>
          <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
            (click)="getClobData1($event, object, 'Header', object.header, 'viewName')">
            <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
            <span class="ms-1">View</span>
          </button>
        </div>
      </td>

      <td style="min-width: 250px;max-width:250px;">
        <div class="download-button-continer btn-align" mat-dialog-actions>
          <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
            (click)="getClobData1($event, object, 'Footer', object.footer, 'viewName')">
            <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
            <span class="ms-1">View</span>
          </button>
        </div>
      </td>



      <td class="sticky-col first-col" style="border:none !important;">
        <div class="action-icons">
          <i *ngIf="object.addForm == 'Y' && object.status !='Completed'" class="fa-solid fa-pencil" matTooltip="Edit"
            style="margin-left: 5px;" (click)="editForm(object,$event)" (keydown.enter)="editForm(object,$event)"></i>
          <i *ngIf="object.addForm == 'Y' && object.status !='Completed'" class="fa-solid fa-user" title="Add Users"
            style="margin-left: 5px;" (click)="addFormusersFunc(object,$event)"
            (keydown.enter)="addFormusersFunc(object,$event)"></i>
          <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
            style="margin-left: 5px;" (click)="openAuditTrail('individual',object)"
            (keydown.enter)="openAuditTrail('individual',object)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="pagination_text mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #editFormPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Form</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-6" [hidden]="visibleEditButton">
          <div><label id="template-select-container" for="email">Template</label><span class="mandatory-symbol">*</span>
          </div>
          <div>
            <mat-select matInput placeholder="Select" [(ngModel)]="selectedTemplate" (closed)="templateSearchText=''"
              (click)="focusSearch('focus-template-search')" (keydown.enter)="focusSearch('focus-template-search')"
              (focusout)="onFieldFocusout()">
              <input type="search" id="template-search" class="dropdownsearchstyle"
                [(ngModel)]="templateSearchText" matInput placeholder="search">
              <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
              <mat-option *ngFor="let item of templateToAddFormDropdown | assessmentSearch : templateSearchText"
                [value]="item.valueExp">
                {{ item.displayExp }}
              </mat-option>
            </mat-select>
          </div>
          <span id="template-required-msg">Please select template</span>
        </div>
        <div class="col-md-6">
          <div>
            <label id="formNameForEdit" for="email ">Form Name</label><span class="mandatory-symbol">*</span>
          </div>
          <input class="input-filed-continers" type="text" [(ngModel)]="formObj.formName"
            (focusout)="onFieldFocusout()">
          <span id="formNameForEdit-required-msg">Please enter an form name</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10">
          <div><label for="email ">Form Description</label></div>
          <textarea class="textarea-filed-continers" type="text" [(ngModel)]="formObj.formDescription"
            (input)="limitCharacters($event, 'FORM_DESCRIPTION')"></textarea>
        </div>
      </div>
      <br>
      <div class="row" [hidden]="visibleAddButton">
        <div class="col-md-6">
          <div><label for="email">Header</label></div>
          <div class="row">
            <div class="hideToolbar col-sm-11">
              <st-editor [(ngModel)]="formObj.header" [config]="excludeButtons" [spellcheck]="true"
                (ngModelChange)="limitEditorContent($event, 'HEADER')"></st-editor>

            </div>
            <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Header')"
              (keydown.enter)="openEditor('Header')">
              <i class="far fa-edit"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div><label for="email">Footer</label></div>
          <textarea class="textarea-filed-continers" type="text" [(ngModel)]="formObj.footer"
            (input)="limitCharacters($event, 'FOOTER')"></textarea>

        </div>
      </div>
      <br [hidden]="visibleAddButton">
      <br>
    </div>
  </div>
  <br>

  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(formObj)" (keydown.enter)="addAndEditFunction(formObj)" *ngIf="!visibleEditButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(formObj)" (keydown.enter)="addAndEditFunction(formObj)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #addUserPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddUserFunc()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Add User</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">

      <div class="row" style="margin-bottom: 5%;">
        <div class="col-md-10">
          <div><label for="email ">Handle Form Users</label></div>
          <mat-select matInput multiple placeholder="Select" #handler [(ngModel)]="selectedHandleUser"
            (closed)="handleUserSearchText=''" (click)="focusSearch('focus-department-search')"
            (keydown.enter)="focusSearch('focus-department-search')">
            <input type="search" id="focus-department-search" class="dropdownsearchstyle"
              [(ngModel)]="handleUserSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="handleUserSelection" (change)="toggleAllSelection('handler')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of formUsersDropdown | multiAssessmentSearchPipe : handleUserSearchText"
              [value]="item.valueExp" (onSelectionChange)="onHandleFormUserSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-10">
          <div><label for="email ">Verify Form Users</label></div>
          <mat-select matInput multiple placeholder="Select" #verifier [(ngModel)]="selectedVerifyUser"
            (closed)="verifierSearchText=''" (click)="focusSearch('focus-verifier-search')"
            (keydown.enter)="focusSearch('focus-verifier-search')">
            <input type="search" id="focus-verifier-search" class="dropdownsearchstyle" [(ngModel)]="verifierSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="verifierSelection" (change)="toggleAllSelection('verifier')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of formUsersDropdown | multiAssessmentSearchPipe : verifierSearchText"
              [value]="item.valueExp" (onSelectionChange)="onHandleFormUserSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addUserForForm()">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddUserFunc()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #formUserPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFormUserFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Form User</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <app-form-template-users [data]="formObj"></app-form-template-users>
  </div>
</ng-template>

<ng-template #angularEditor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeAngularEditor()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]="includeButtons" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="saveAngularEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="closeAngularEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>